/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {
  MatMenu,
  _MatMenuBase,
  MAT_MENU_DEFAULT_OPTIONS,
  MatMenuDefaultOptions,
  MenuCloseReason,
} from './menu';
export * from './menu-item';
export * from './menu-content';
export {
  MatMenuTrigger,
  _MatMenuTriggerBase,
  MAT_MENU_SCROLL_STRATEGY,
  MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER,
  MENU_PANEL_TOP_PADDING,
} from './menu-trigger';
export * from './module';
export * from './menu-animations';
export * from './menu-positions';
export * from './menu-panel';



// WEBPACK FOOTER //
// ../../../../../src/material/menu/public-api.ts